import { Injectable } from '@angular/core';
import { catchError, map, retryWhen, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ContactsHttpService } from '@backbase/data-ang/contact-manager';
import { ContactsPostRequestBody } from '@backbase/contact-manager-http-ang/model/models';
import { of } from 'rxjs';
import { OtpAction } from '../interfaces';
import { genericRetryStrategy } from 'src/app/views/components/ui-components/src/utils/util-service';

@Injectable()
export class OtpService {
  private readonly saveBeneficiaryUrl = '/api/banesco-confirmation-service/v2/confirmation/saveBeneficiary';
  static currentOtpMethod: OtpAction;
  static isResend = false;

  constructor(private _httpClient: HttpClient, private _contactsService: ContactsHttpService) {}

  requestOtpValidationAndSaveContact(contact: ContactsPostRequestBody) {
    const bodyParams = { contact: contact, 'confirmation-type': 'save-beneficiary' };
    return this._httpClient.post(this.saveBeneficiaryUrl, bodyParams).pipe(
      map((contactResponse: any) => {
        if (!contactResponse?.contact?.additions) {
          throw new Error('Something went wrong validating the otp.');
        }

        if (Array.isArray(contact?.accounts) && contact.accounts.length < 1) {
          throw new Error('Contact request should include at least one account.');
        }

        contact.additions = contactResponse.contact.additions;
        if (contact.accounts?.[0].additions?.['currencyCode']) {
          contact.accounts[0].additions['currencyCode'] = contactResponse.contact.accounts?.[0].currencyCode;
        }

        return contact;
      }),
      switchMap((beneficiaryParams) =>
        this._contactsService.postContacts({ contactsPostRequestBody: beneficiaryParams }).pipe(
          retryWhen(
            genericRetryStrategy({
              maxRetryAttempts: 2,
              scalingDuration: 1000,
              retryWithStatusCodes: [401],
            }),
          ),
        ),
      ),
      catchError((error) => {
        console.log('Error', error);
        return of(error);
      }),
    );
  }
}
